import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DtoCustomer, createDtoCustomer, CustomFieldSection, createCustomFieldSection, createCustomFieldValue } from '../../common/types/AllTypesExports';
import CustomFieldEditor from './CustomFieldEditor.vue';

@Component({
    components: {
        CustomFieldEditor
    }
})

export default class CustomFieldSectionEditor extends Vue {
    //External
    @Prop({ required: true, default: () => createCustomFieldSection() })
    value!: CustomFieldSection;

    @Prop({ required: false, default: '' })
    scope!: string;

    @Prop({ required: false, default: "" })
    prefix?: string;

    @Prop({ required: true, default: () => createDtoCustomer() })
    customer!: DtoCustomer;

    get sectionTitle() {
        return this.value.name ? this.value.name : null;
    }

    get sectionDescription() {
        return this.value.description ? this.value.description : null;
    }

    get sectionCustomFields() {
        return this.value.customFields.filter(c => c.keyInformation);
    }

    // After matching an existing customer, customFields only has prior DB values.
    // v-model on missing keys binds to an ephemeral prop default and may never
    // write back into customer.customFields (AMS-23374). Ensure each visible
    // Key Info slot exists before the editors bind.
    @Watch('customer.customFields', { immediate: true })
    @Watch('sectionCustomFields', { immediate: true })
    ensureKeyInfoCustomFieldSlots() {
        if (!this.customer) {
            return;
        }

        if (!this.customer.customFields) {
            this.$set(this.customer, 'customFields', {});
        }

        for (const field of this.sectionCustomFields) {
            const existing = this.customer.customFields[field.id];
            if (!existing) {
                this.$set(this.customer.customFields, field.id, createCustomFieldValue({
                    customFieldId: field.id,
                    value: null,
                    isSummation: false
                }));
                continue;
            }

            if (!existing.customFieldId) {
                this.$set(existing, 'customFieldId', field.id);
            }
        }
    }
}